import { lazy } from 'react';

export const PortalSettingsPageLazy = lazy(() => import('./PortalSettingsPage'));
